export default __webpack_public_path__ + "justhatched-second-screens.11cc2145.png";